import {
  JOB_CONFIGS_URL,
  JOB_CONFIG_URL,
  SEARCH_JOB_CONFIGS_URL,
  PRODUCT_BACKGROUNDS_URL,
  PRODUCT_BACKGROUND_URL,
  PRODUCT_OVERLAYS_URL,
  MOMENT_UPLOAD_URL,
  PRODUCT_KNOCKOUT_PAIRS_URL,
  PRODUCT_KNOCKOUT_PAIR_URL,
  PRODUCT_BACKGROUND_DELETE_URL,
  PRODUCT_OVERLAY_DELETE_URL,
  DISCOUNTS_CODE_URL,
  DISCOUNT_CODE_URL,
  PRICINGS_TIERS_URL,
  PRICING_TIERS_URL,
  BACKGROUND_ASPECT_URL,
  OVERLAY_ASPECT_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
  destroy
} from 'app/services/ApiService';

export const getJobConfigs = async params => {
  return await post(SEARCH_JOB_CONFIGS_URL(), params);
}

export const createJobConfig = async params => {
  return await post(JOB_CONFIGS_URL(), params);
}

export const updateJobConfig = async (id, params) => {
  return await put(JOB_CONFIG_URL(id), params);
}

export const destroyJobConfig = async id => {
  return await destroy(JOB_CONFIG_URL(id));
}

export const getProductBackgrounds = async (accountId, productId) => {
  return await get(PRODUCT_BACKGROUNDS_URL(accountId, productId));
}

export const createProductBackground = async (accountId, params) => {
  return await post(PRODUCT_BACKGROUND_URL(accountId), params);
}

export const getProductAssetSignedUrl = async (momentId, type, asJson) => {
  return await get(MOMENT_UPLOAD_URL(momentId, type, asJson));
}

export const getProductOverlays = async (productId) => {
  return await get(PRODUCT_OVERLAYS_URL(productId));
}

export const createProductOverlays = async (productId, params) => {
  return await post(PRODUCT_OVERLAYS_URL(productId), params);
}

export const getProductKnockoutPairs = async (accountId, productId) => {
  return await get(PRODUCT_KNOCKOUT_PAIRS_URL(accountId, productId));
}

export const createProductKnockOutPair = async (accountId, productId, params) => {
  return await post(PRODUCT_KNOCKOUT_PAIRS_URL(accountId, productId), params);
}

export const updateProductKnockoutPair = async (accountId, productId, knockoutPairId, params) => {
  return await put(PRODUCT_KNOCKOUT_PAIR_URL(accountId, productId, knockoutPairId), params);
}

export const deleteProductKnockoutPair = async (accountId, productId, knockoutPairId) => {
  return await destroy(PRODUCT_KNOCKOUT_PAIR_URL(accountId, productId, knockoutPairId));
}

export const deleteProductBackground = async (accountId, productId, backgroundId) => {
  return await destroy(PRODUCT_BACKGROUND_DELETE_URL(accountId, productId, backgroundId));
}

export const deleteProductOverlay = async (productId, overlayId) => {
  return await destroy(PRODUCT_OVERLAY_DELETE_URL(productId, overlayId));
}

export const deleteBackgroundAspect = async (accountId, backgroundId, aspectId) => {
  return await destroy(BACKGROUND_ASPECT_URL(accountId, backgroundId, aspectId));
}

export const deleteOverlayAspect = async (productId, overlayId, aspectId) => {
  return await destroy(OVERLAY_ASPECT_URL(productId, overlayId, aspectId));
}

export const createDiscountCode = async (productId, params) => {
  return await post(DISCOUNTS_CODE_URL(productId), params);
}

export const getDiscountCode = async (productId) => {
  return await get(DISCOUNTS_CODE_URL(productId));
}

export const updateDiscountCode = async (productId, id, params) => {
  return await put(DISCOUNT_CODE_URL(productId, id), params);
}

export const deleteDiscountCode = async (productId, id) => {
  return await destroy(DISCOUNT_CODE_URL(productId, id));
}

export const getPricingTiers = async (productId) => {
  return await get(PRICINGS_TIERS_URL(productId));
}

export const createPricingTier = async (productId, params) => {
  return await post(PRICINGS_TIERS_URL(productId), params);
}

export const updatePricingTier = async (productId, id, params) => {
  return await put(PRICING_TIERS_URL(productId, id), params);
}

export const deletePricingTier = async (productId, id) => {
  return await destroy(PRICING_TIERS_URL(productId, id));
}
